import { Button } from "../../../components/atoms/Button";
import {
  BaseModalProps,
  BaseModal,
} from "../../../components/organisms/modal/BaseModal";

export interface MaintenanceModalProps extends BaseModalProps {
  onClick?: () => void;
}

export const MailtenanceModal = ({
  onDismiss,
  onClick,
  ...props
}: MaintenanceModalProps) => {
  const handleClick = () => {
    onDismiss();
    if (onClick) onClick();
  };

  return (
    <BaseModal
      title="🚧 只今メンテナンス中です 🚧"
      subTitle={`ご迷惑をおかけし申し訳ございません。\n2023年03月8日(水)22:00~27:00までメンテナンスを行なっております。\nメンテナンス終了までもう暫くお待ちください。\n\n2023年03月8日(水)22:00~27:00の間に電話鑑定の予約が確定している場合、お手数ですが日程の再調整をお願いいたします。`}
      onDismiss={onDismiss}
      {...props}
    >
      <Button tw="bg-gradient-theme-to-l w-full" onClick={handleClick}>
        OK
      </Button>
    </BaseModal>
  );
};
